module.exports = __webpack_public_path__ + "img/step26_a_remove_stacker_adapters.185ccc5b.png";